import React, { FunctionComponent } from "react"

interface CoffeeIconProps {
  color?: string
}

const CoffeeIcon: FunctionComponent<CoffeeIconProps> = ({ color="#ffffff" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1992_272)">
        <path
          d="M12 5.33301H12.6667C13.3739 5.33301 14.0522 5.61396 14.5523 6.11406C15.0524 6.61415 15.3333 7.29243 15.3333 7.99967C15.3333 8.70692 15.0524 9.3852 14.5523 9.88529C14.0522 10.3854 13.3739 10.6663 12.6667 10.6663H12"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.33325 5.33301H11.9999V11.333C11.9999 12.0403 11.719 12.7185 11.2189 13.2186C10.7188 13.7187 10.0405 13.9997 9.33325 13.9997H3.99992C3.29267 13.9997 2.6144 13.7187 2.1143 13.2186C1.6142 12.7185 1.33325 12.0403 1.33325 11.333V5.33301Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 0.666992V2.66699"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.66675 0.666992V2.66699"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.33325 0.666992V2.66699"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1992_272">
          <rect width="16" height="16" fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CoffeeIcon
